const fontList = [
  { name: 'Aller', type: 'sans-serif' },
  { name: 'Arial', type: 'sans-serif' },
  // { name: 'Brush Script MT', type: 'cursive' },
  { name: 'Courier New', type: 'monospace' },
  // { name: 'Garamond', type: 'serif' },
  { name: 'Georgia', type: 'serif' },
  { name: 'Helvetica', type: 'sans-serif' },
  // { name: 'Palatino', type: 'serif' },
  { name: 'Verdana', type: 'sans-serif' },
  { name: 'Tahoma', type: 'sans-serif' },
  { name: 'Times New Roman', type: 'serif' },
].sort();

module.exports = fontList;
module.exports.applyFont = function(fontName) {
  let fontIdx = fontList.findIndex(a => a.name === fontName);
  if (fontIdx < 0 || fontIdx > fontList.length) fontIdx = 0;

  const font = fontList[fontIdx];
  document.documentElement.style.setProperty(
    '--defaultFont', ((font) ? `${font.name}, ${font.type}` : 'Aller, sans-serif')
  );
  return font;
};



// WEBPACK FOOTER //
// ./src/utils/fonts.js